import React from "react";
import styles from "./KeepPlayingDelaySelector.module.css";
import {Label} from "../Label/Label";
import { t } from "../../lib/i18n";

export const SlideDelayOption = ({setDelay, label, delayValue, selected, enabled=true}) => {

    return (
        <div className={styles.selectSpeed} onClick={() => setDelay(delayValue)}
             data-selected={selected} data-enabled={enabled}>
            {label}
        </div>
    )
}

export const KeepPlayingDelaySelector = ({delay, setDelay, enabled=true}) => {

    const slideDelayOptions = [
        { label: "3x", value: 2500},
        { label: "2x", value: 1000},
        { label: "1x", value: 300},
    ]

    return (

        <div className={styles.timeInterval}>

            <Label enabled={enabled}>{t("Tempo de Intervalo")}</Label>

            <div className={styles.containerOptions}>
                {slideDelayOptions.map((option, index) => {
                    return (
                        <SlideDelayOption key={index} setDelay={setDelay} label={option.label} delayValue={option.value}
                                          selected={delay === option.value}
                                          enabled={enabled}
                        />
                    )
                })}
            </div>
        </div>
    )
}